<template>
  <div class="header_content2">
    <div class="header_content2_logo1"><img :src="header_loge1" /></div>
    <div class="header_content2_logo2"><img :src="header_loge2" /></div>
    <div class="header_content2_logo3">海外邦人向け現地情報アーカイブ</div>
    <div class="header_content2_list">
      <router-link :to="'/index'">
        <div class="header_content2_list_item" v-bind:class="{header_content2_click:this.$store.state.routerUrl=='index'}">首页</div>
      </router-link>
      <!-- <router-link :to="'#'"> -->
      <a>
        <div class="header_content2_list_item" v-bind:class="{header_content2_click:this.$store.state.routerUrl=='index'}">ガイド</div>
      </a>
      <!-- </router-link> -->
      <router-link :to="'/find'">
        <div class="header_content2_list_item" v-bind:class="{header_content2_click:this.$store.state.routerUrl=='find'}">発見</div>
      </router-link>
      <router-link :to="'/livaiaFM'">
        <div class="header_content2_list_item" v-bind:class="{header_content2_click:this.$store.state.routerUrl=='livaiaFM'}">LivAiA FM</div>
      </router-link>
      <!-- <router-link :to="'/#'"> -->
      <a>
        <div class="header_content2_list_item" v-bind:class="{header_content2_click:this.$store.state.routerUrl=='index'}">フリマガ</div>
      </a>
      <!-- </router-link> -->
    </div>
    <div class="header_content2_search">
      <div class="header_content2_search_input"><input /></div>
      <div class="header_content2_search_img"><img :src="search" /></div>
    </div>
    <div class="header_content2_download">ダウンロード</div>
    <div class="header_content2_publish pointer" @mousemove="onmouseoverFun"><img :src="announcement_icon" /> &nbsp;発表</div>
    <div class="header_content1_announcement_float" v-show="onmoouse" @mousemove="onmouseoverFuns" @mouseout="onmouseoutFun">
      <div class="header_content1_announcement_float_item" @click="pushFun('articleManage')"><div class="header_content1_announcement_float_item_icon"><img :src="announcement_float_item_icon1"/></div>記事を投稿</div>
      <div class="header_content1_announcement_float_item" @click="pushFun('videoManage')"><div class="header_content1_announcement_float_item_icon"><img :src="announcement_float_item_icon2"/></div>発見動画</div>
      <div class="header_content1_announcement_float_item" @click="pushFun('postManage')"><div class="header_content1_announcement_float_item_icon"><img :src="announcement_float_item_icon3"/></div>発見投稿</div>
    </div>
    <div class="header_content2_login pointer" v-if="!this.$store.state.token" @click="loginResFun()">登录</div>
    <div class="header_content2_login_img pointer" v-if="this.$store.state.token"><router-link :to="'/pagehome'"><img :src="this.$store.state.userInfo.avatar" /></router-link></div>
  </div>
</template>

<script>
import header_loge1 from "@/assets/imgs/header_logo1.png"
import header_loge2 from "@/assets/imgs/header_logo2.png"
import announcement_icon from "@/assets/imgs/announcement_icon.png"
import wechat from "@/assets/imgs/wechat.png"
import facebook from "@/assets/imgs/facebook.png"
import twitter from "@/assets/imgs/twitter.png"
import search from "@/assets/imgs/search.png"
import announcement_float_item_icon1 from "@/assets/imgs/announcement_float_item_icon1.png"
import announcement_float_item_icon2 from "@/assets/imgs/announcement_float_item_icon2.png"
import announcement_float_item_icon3 from "@/assets/imgs/announcement_float_item_icon3.png"
export default {
  data() {
    return {
      header_loge1: header_loge1,
      header_loge2: header_loge2,
      announcement_icon: announcement_icon,
      wechat: wechat,
      facebook: facebook,
      twitter: twitter,
      search: search,
      announcement_float_item_icon1: announcement_float_item_icon1,
      announcement_float_item_icon2: announcement_float_item_icon2,
      announcement_float_item_icon3: announcement_float_item_icon3,
      onmoouse: false,
    }
  },
  methods: {
    onmouseoverFun(){
      this.onmoouse = true
      const that = this;
      setTimeout(function(){
        if(that.onmoouse){
          that.onmoouse = false
        }
      },5000)
    },
    onmouseoverFuns(){
      this.onmoouse = true
    },
    onmouseoutFun(){
      this.onmoouse = false
    },
    pushFun(url){
      if(!this.$store.state.token){
        this.loginResFun()
        return false
      }
      this.$router.push(url)
    },
    loginResFun(){
      this.$parent.loginResFun()
    }
  },    
}
</script>

<style scoped>
.header_content2 .header_content1_announcement_float{
  right: 84px;
}
.header_content2{
  width: 1920px;
  height: 69px;
  background: #113651;
  position: relative;
}
.header_content2_logo1{
  width: 39px;
  height: 39px;
  position: absolute;
  top: 12px;
  left: 31px;
}
.header_content2_logo1 img{
  width: 39px;
  height: 39px;
}
.header_content2_logo2{
  width: 158px;
  height: 23px;
  position: absolute;
  top: 14px;
  left: 81px;
}
.header_content2_logo2 img{
  width: 158px;
  height: 23px;
}
.header_content2_logo3{
  height: 11px;
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 10px;
  position: absolute;
  top: 41px;
  left: 81px;
}
.header_content2_list{
  position: absolute;
  top: 13px;
  left: 326px;
}
.header_content2_list_item{
  height: 44px;
  text-align: center;
  display: inline-block;
  line-height: 44px;
  font-size: 18px;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
}
.header_content2_list a{
  margin-left: 32px;
}
.header_content2_list a:first-child{
  margin-left: 0px;
}
.header_content2_click{
  background: #EBEBEB;
  border-radius: 6px;
  color: #000000;
  padding: 0px 22px;
}
.header_content2_search{
  width: 283px;
  height: 34px;
  background: #DDDDDD;
  border-radius: 7px;
  position: absolute;
  top: 18px;
  left: 1258px;
}
.header_content2_search_input{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.header_content2_search_input input{
  width: 233px;
  height: 30px;
  outline: none;
  border: 1px solid #EBEBEB;
  border-radius: 7px;
  background: #DDDDDD;
  padding-left: 10px;
  padding-right: 40px;
}
.header_content2_search_img{
  width: 21px;
  height: 21px;
  position: absolute;
  top: 6px;
  right: 11px;
  z-index: 2;
}
.header_content2_search_img img{
  width: 21px;
  height: 21px;
}

.header_content2_download{
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  position: absolute;
  top: 26px;
  left: 1576px;
  cursor: pointer;
}
.header_content2_publish{
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  position: absolute;
  top: 23px;
  left: 1704px;
  line-height: 16px;
}
.header_content2_publish img{
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.header_content2_login{
  width: 67px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #113651;
  line-height: 28px;
  text-align: center;
  position: absolute;
  top: 21px;
  right: 47px;
}
.header_content2_login_img{
  width: 24px;
  height: 24px;
  position: absolute;
  top: 23px;
  right: 100px;
}
.header_content2_login_img img{
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.header_content1_announcement_float{
  width: 162px;
  padding: 6px 0px;
  background: #FFFFFF;
  box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  position: absolute;
  top: 73px;
  right: 144px;
}
.header_content1_announcement_float_item{
  width: 162px;
  height: 39px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 39px;
  cursor: pointer;
}
.header_content1_announcement_float_item_icon{
  width: 25px;
  height: 25px;
  margin-left: 25px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}
.header_content1_announcement_float_item_icon img{
  width: 25px;
  height: 25px;
}
.header_content2 .header_content1_announcement_float{
  right: 84px;
}
.pointer{
  cursor: pointer;
}
</style>
